import React from 'react';

import SvgIcon, { SvgIconProps } from './SvgIcon';

const PrexoIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox={[512, 512]}
    d="M20 32C9 32 0 41 0 52S9 72 20 72l12 0 0 248c0 35.3 28.7 64 64 64l140 0 0 41.6-71.5 50c-9 6.3-11.2 18.8-4.9 27.8s18.8 11.2 27.8 4.9l68.5-48 68.5 48c9 6.3 21.5 4.1 27.8-4.9s4.1-21.5-4.9-27.8l-71.5-50 0-41.6 140 0c35.3 0 64-28.7 64-64l0-248 12 0c11 0 20-9 20-20s-9-20-20-20L20 32zM440 72l0 248c0 13.3-10.7 24-24 24L96 344c-13.3 0-24-10.7-24-24l0-248 368 0z"
  />
);

export default PrexoIcon;
